/**
 * RailInterviewReadiness — fetches readiness and renders the compact rail gauge.
 * Shown in the dashboard right rail (md+) next to the community feed.
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import api from '../../api/client';
import InterviewReadinessScore from '../progress/InterviewReadinessScore';

export default function RailInterviewReadiness({ onViewProgress }) {
  const [loading, setLoading] = useState(true);
  const [readiness, setReadiness] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchScore() {
      try {
        const res = await api.progress.getReadinessScore();
        if (cancelled) return;
        setReadiness(res?.data || res || null);
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchScore();
    return () => { cancelled = true; };
  }, []);

  if (error) return null;

  return (
    <InterviewReadinessScore
      variant="rail"
      loading={loading}
      score={readiness?.score ?? 0}
      components={readiness?.components || {}}
      change={readiness?.change}
      onViewProgress={onViewProgress}
    />
  );
}

RailInterviewReadiness.propTypes = {
  onViewProgress: PropTypes.func,
};
